module.exports = __webpack_public_path__ + "assets/img/blue.111e4f5b.png";